import React from 'react';
import { COPY } from './copy';

// Combined statuses render in a single colour, never mixed (sc-28528): an
// INFO ADDED status matches the IN PROGRESS blue, INFO REQUESTED is red.
const BADGES = {
  open_info_requested: { label: COPY.status.openInfoRequested, color: COPY.hex.alertRed },
  open_info_added: { label: COPY.status.openInfoAdded, color: COPY.hex.inProgress },
  closed_info_requested: { label: COPY.status.closedInfoRequested, color: COPY.hex.alertRed },
  closed_info_added: { label: COPY.status.closedInfoAdded, color: COPY.hex.closedBlue },
};

const RaiStatusBadge = ({ overlay }) => {
  const config = BADGES[overlay];
  if (!config) return null;

  // Statuses render as colour-coded text (not filled pills) so they don't look
  // like the action buttons beside them (sc-28540).
  return (
    <span
      className="inline-block text-xs font-semibold uppercase px-2 py-1"
      style={{ color: config.color }}
    >
      {config.label}
    </span>
  );
};

export default RaiStatusBadge;
